import { render, staticRenderFns } from "./Comic.vue?vue&type=template&id=2a6a158a&scoped=true&"
import script from "./Comic.vue?vue&type=script&lang=js&"
export * from "./Comic.vue?vue&type=script&lang=js&"
import style0 from "./Comic.vue?vue&type=style&index=0&id=2a6a158a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6a158a",
  null
  
)

export default component.exports